import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "@/lib/api";

const FundContext = createContext(null);

export function FundProvider({ children }) {
  const [activeFund, setActiveFund] = useState(null);
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();

  const portalMatch = pathname.match(/\/super-admin\/funds\/([^/]+)\/(portal|apps)/);
  const urlFundId = portalMatch?.[1];

  useEffect(() => {
    if (urlFundId && (!activeFund || activeFund.id !== urlFundId)) {
      setLoading(true);
      API.get(`/funds/${urlFundId}`)
        .then(({ data }) => setActiveFund(data))
        .catch(() => setActiveFund(null))
        .finally(() => setLoading(false));
    }
    if (!urlFundId && activeFund) {
      setActiveFund(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlFundId]);

  return (
    <FundContext.Provider value={{ activeFund, setActiveFund, fundLoading: loading }}>
      {children}
    </FundContext.Provider>
  );
}

export function useFund() {
  const ctx = useContext(FundContext);
  if (!ctx) return { activeFund: null, setActiveFund: () => {}, fundLoading: false };
  return ctx;
}
